// @ts-nocheck


import React from 'react';



import { locationApi } from '../../lib/api';
import { resolvePlace, searchPlaces } from '../../lib/gis';
import AutocompleteSelect from './AutocompleteSelect';










export default ({
  valueField = 'id',
  geolocationApi = true,
  ...selectProps
}) =>
<AutocompleteSelect
  fetch={async (params = {}) => {
    let locationsList = await locationApi.fetchLocations({
      ...selectProps.filter,
      ...params
    });
    if (geolocationApi && params.search) {
      try {
        const suggestions = await searchPlaces(params.search);
        locationsList.data = [...locationsList.data, ...suggestions];
      } catch (error) {
        // Ошибка внешнего поиска не должна прятать объекты справочника
        console.error(error);
      }
    }
    return locationsList;
  }}
  fetchSingle={locationApi.fetchLocation}
  notFoundText="Объекты не найдены"
  renderOption={(location, Option) => {
    return (
      <Option
        value={location[valueField] || location.name}
        key={location.id || location.name}
        location={location}>

          {location.name}
        </Option>);

  }}
  {...selectProps}
  onChange={async (value, option) => {
    const { onChange, onSelect } = selectProps;
    if (option) {
      const { location } = option.props;
      if (location.placeId) {
        const { lat, lng } = await resolvePlace(location);
        location.latitude = lat;
        location.longitude = lng;
      }
      if (onSelect) onSelect(value, option);
    }
    if (onChange) onChange(value, option);
  }} />;
